import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApiConfiguration } from 'nekst-api';
import { ChatWidgetContextProvider } from './ChatWidgetContext';
import ChatFab from './Layout/Components/ChatFab';
import ChatWidgetLayout from './Layout';

function setCrispVisibility(visible: boolean) {
  const w = window as Record<string, unknown>;
  if (typeof w.$crisp === 'object' && w.$crisp && 'push' in (w.$crisp as object)) {
    const $crisp = w.$crisp as Array<unknown[]>;
    $crisp.push(['do', `chat:${visible ? 'show' : 'hide'}`]);
  }
}

function ChatWidgetInner() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setCrispVisibility(!isOpen);
    return () => setCrispVisibility(true);
  }, [isOpen]);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleMinimize = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleExpand = useCallback((conversationId: number | null) => {
    if (conversationId) {
      navigate(`/chats/${conversationId}`);
    } else {
      navigate('/chats');
    }
  }, [navigate]);

  return (
    <ChatWidgetContextProvider>
      {isOpen ? (
        <ChatWidgetLayout
          onMinimize={handleMinimize}
          onClose={handleClose}
          onExpand={handleExpand}
        />
      ) : (
        <ChatFab onClick={handleOpen} />
      )}
    </ChatWidgetContextProvider>
  );
}

export function ChatWidget() {
  const { streamingGatewayUrl } = useApiConfiguration();
  const { pathname } = useLocation();

  if (!streamingGatewayUrl || pathname.startsWith('/chats')) {
    return null;
  }

  return <ChatWidgetInner />;
}
